import React, { useCallback, useState } from "react";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import ContentHeader from "../../../components/shared/ContentHeader";
import UsersTable from "./Table";
import AddEditUsers from "./AddEditModal";
import { useTenantUsers } from "../../../hooks/useTenantUsers";

const Users = () => {
  const [selectedUser, setSelectedUser] = useState(null);

  const { users, loading, selectedTenantId } = useTenantUsers();

  const showModal = useCallback((data = null) => {
    //@ts-ignore
    setSelectedUser(data || {});
  }, []);

  const handleCancel = useCallback(() => {
    setSelectedUser(null);
  }, []);

  return (
    <div>
      <ContentHeader title={"Users"}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => showModal()}
        />
      </ContentHeader>
      <UsersTable loading={loading} users={users} showModal={showModal} />
      {selectedUser && (
        <AddEditUsers
          selectedUser={selectedUser}
          handleCancel={handleCancel}
          users={users}
          selectedTenantId={selectedTenantId}
        />
      )}
    </div>
  );
};

export default Users;
